import axios from 'axios';

export async function sendContactEmail(contact) {
  // This endpoint is public; Gmail authorization belongs to the server.
  await axios.post('/api/contact/send-email', contact, {
    headers: { 'Content-Type': 'application/json' }
  });
}
